/*! @azure/msal-browser v3.26.1 2024-10-08 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";
export { contentError, userSwitch };